import $ from "jquery";
import "@babel/polyfill/noConflict";
import Foundation from "./_foundation"; // import "motion-ui/dist/motion-ui";

import throttle from "lodash/throttle";
import _ from "lodash"; // import AOS from 'aos'
// import '../../node_modules/jquery-parallax.js/parallax.min.js'

import "../../node_modules/focus-visible/dist/focus-visible.min.js";
import { inlineSVG } from "./_inline-svg";
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange } from "./_lazy-load"; // import { smoothScrollOnPageLoad } from "./_smoothScrollOnPageLoad";

import "./_skip-link-focus-fix";
import "./_acf-map";
import "./_fixed-header"; // import "./_header-height";
// import './_hero-slider'

import "./_notification";
import "./_scroll-to-top";
import "./_slick";
import "./_social-share-sticky";
import "./_off-canvas"; // import './_faqs_accordion'
// import "./_fragmentURLs";

/* Additional Scripts */
// import { randomString } from './_random-string'
// import { equalHeights } from './_equal-height'

import "./_ie";
import "./_site-header-search"; // Foundation

$(document).foundation(); // Inline SVG

inlineSVG(); // Smooth Scroll on page load
// smoothScrollOnPageLoad();
// Lazy-load on DOMContentLoaded

window.addEventListener("DOMContentLoaded", function () {
  lazyImages();
  lazyBackgrounds();
  lazyVideos();
  lazyOembeds();
  lazyInterchange();
}, false); // Lazy-load on scroll event

window.addEventListener("scroll", throttle(lazyImages, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyBackgrounds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyOembeds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyInterchange, 75), {
  passive: true
}); // AOS
// AOS.init();

/**
 * Scroll reveal header
 */

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var $siteHeight = $(".site-header.site-header--scroll-reveal");
var navbarHeight = $siteHeight.outerHeight(); // var screenSize = Foundation.MediaQuery.current;
// Seup of detection the scroll direction

function detectScrollDirection() {
  $(window).scroll(function (event) {
    didScroll = true;
  });
  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 150);

  function hasScrolled() {
    var scrollTop = $(window).scrollTop(); // Make sure they scroll more than delta.

    if (Math.abs(lastScrollTop - scrollTop) <= delta) {
      return;
    } // Scrolled down.


    if (scrollTop > lastScrollTop) {
      $siteHeight.removeClass("js-nav-down").addClass("js-nav-up");
    } // Scrolled up.
    else {
        // Scroll Up
        if (scrollTop < navbarHeight + delta) {
          $siteHeight.removeClass("js-nav-down").addClass("js-nav-up");
        } else if (scrollTop + $(window).height() < $(document).height()) {
          $siteHeight.removeClass("js-nav-up").addClass("js-nav-down");
        }
      }

    lastScrollTop = scrollTop;
  }
} // Init detection on load
// detectScrollDirection();


var setCookie = function setCookie(name, value, daysToLive) {
  var cookie = name + "=" + encodeURIComponent(value);

  if (typeof daysToLive === "number") {
    cookie += "; max-age=" + daysToLive * 24 * 60 * 60;
    document.cookie = cookie;
  }
}; // $("body").html(
//     $("body")
//         .html()
//         .replace(/Subscription/g, "Membership")
// );


$(".js-newsletter").on("click", function (e) {
  e.preventDefault();
  $(".newsletter-popup").slideToggle();
  setCookie("newsletter", true, 1);
});
$(".js-mobile .site-footer__header").on("click", function (e) {
  e.preventDefault();
  $(this).siblings("div").slideToggle();
});
$(".js-register").on("click", function (e) {
  e.preventDefault();
  $(".login").hide();
  $(".register").fadeIn("slow");
});

if (location.href.indexOf("#register") != -1) {
  $(".login").hide();
  $(".register").fadeIn("slow");
}

$(".woocommerce-notices-wrapper ul").on("click", function (e) {
  e.preventDefault();
  $(this).slideUp();
});
$(".js-search").on("click", function (e) {
  e.preventDefault();
  $(this).toggleClass("active");
  $(".search-form").fadeToggle();
});
var allCheckboxes = document.querySelectorAll("input[type=checkbox]");
var allFilters = Array.from(document.querySelectorAll(".js-filter-item"));
var checked = {};
getChecked("jsfilter");
Array.prototype.forEach.call(allCheckboxes, function (el) {
  el.addEventListener("change", toggleCheckbox);
});

function toggleCheckbox(e) {
  getChecked(e.target.name);
  setVisibility();
}

function getChecked(name) {
  checked[name] = Array.from(document.querySelectorAll("input[name=" + name + "]:checked")).map(function (el) {
    return el.value;
  });
}

function setVisibility() {
  allFilters.map(function (el) {
    var jsfilter = checked.jsfilter.length ? _.intersection(Array.from(el.classList), checked.jsfilter).length : false;

    if (jsfilter) {
      el.style.display = "flex";
    } else {
      el.style.display = "none";
    }
  });
}

if ($(".js-price").length) {
  if ($(".js-price input").val() == "0.00" || $(".js-price input").val() == "0") {
    $(".gfield_creditcard_warning").hide();
    $(".js-coupon").hide();
    $(".js-price").hide();
  }
}

$(".js-member-search").on("click", function () {
  var $name = $("#name").val().toLowerCase();
  var $chapter = $("#chapter").val();
  var $type = $("#type").val();
  $(".border").show();

  if ($name != "") {
    $(".border").fadeOut("fast");
    $('.border[data-name*="' + $name + '"]').fadeIn("fast");
  }

  if ($chapter != 0) $('.border[data-chapter!="' + $chapter + '"]').fadeOut("fast");
  if ($type != 0) $('.border[data-type!="' + $type + '"]').fadeOut("fast");
});
$(".js-continue").on("click", function (e) {
  e.preventDefault();
  $(this).parent().fadeOut();
});
var url = window.location.href;

if (url.indexOf("#") > 0) {
  var activeTab = url.substring(url.indexOf("#") + 1);
  $('.nav[role="tablist"] a[href="#' + activeTab + '"]').tab("show");
  var position = $("#tab-options").offset().top + 300;
  $("html, body").animate({
    scrollTop: position
  }, 1000);
}